import React, { useState } from 'react';
import { useAuth } from '../../../context/AuthContext';
import Enquiries from '../training/Enquiries';
import { InternshipsPage, ProjectsPage } from '../training/InternshipProjectPage';

// Reuse each category's existing forms, permissions and save endpoints.
export default function TrainingLeadsPage() {
  const { canAccessModule, hasPermission, user, role } = useAuth();
  const roleKey = role?.key || user?.roleKey || user?.roleId?.key || '';
  const canManageLeadCategories = user?.userType === 'super_admin'
    || ['admin', 'tenant_admin', 'team_lead'].includes(roleKey);
  const categories = [
    { key: 'enquiries', label: 'Course Enquiry', Component: Enquiries },
    { key: 'internships', label: 'Internship', Component: InternshipsPage },
    { key: 'projects', label: 'Project Guidance', Component: ProjectsPage },
  ].filter(item => canManageLeadCategories || canAccessModule(item.key) || hasPermission(item.key, 'view'));
  const [selected, setSelected] = useState('');
  const active = categories.find(item => item.key === selected) || categories[0];
  if (!active) return <div className="alert alert-warning">You do not have access to lead management.</div>;
  const CategoryPage = active.Component;
  return <>
    <div className="mb-3" style={{ maxWidth: 320 }}>
      <label className="form-label fw-semibold" htmlFor="crm-lead-category">Lead Category</label>
      <select id="crm-lead-category" className="form-select" value={active.key} onChange={event => setSelected(event.target.value)}>
        {categories.map(item => <option key={item.key} value={item.key}>{item.label}</option>)}
      </select>
    </div>
    <CategoryPage key={active.key} />
  </>;
}
